// KAN-975: из ядра, а не из "zod". Главный вход тянет весь классический слой со всеми языковыми
// файлами (57% распакованного размера zod), а этот модуль едет в общую оболочку каждой страницы
// через instrumentation-client. Настройка лежит в globalThis.__zod_globalConfig, одной на ядро
// и классику, так что запись из ядра действует и на схемы, собранные через "zod".
import { config } from "zod/v4/core";

/**
 * KAN-1016: zod без JIT — чтобы страница перестала требовать `unsafe-eval`.
 *
 * ЧТО ПРОИСХОДИЛО. Консоль прода на каждой загрузке давала пачку отчётов
 * «Evaluating a string as JavaScript violates … 'unsafe-eval'» со ссылками на
 * наши же файлы схем (`organizations schemas.ts`, `notifications.ts`, `user.ts`)
 * и на `VM…` — сгенерированный код. Отчёты приходили от ЦЕЛЕВОЙ политики,
 * которая едет в Report-Only рядом с боевой (см. `src/proxy.ts`, KAN-955): она
 * ничего не блокировала, но показывала, что сломается при её включении.
 *
 * ИСТОЧНИК — zod (v4), и он же двойной:
 * 1. `util.allowsEval` — **проба возможностей**: zod один раз вызывает
 *    `new Function("")` в try/catch, чтобы узнать, разрешён ли eval. Исключение
 *    он проглатывает, но CSP успевает записать нарушение — то есть отчёт
 *    появлялся даже там, где zod прекрасно работал бы и без eval;
 * 2. компиляция схем: узнав, что eval доступен, zod собирает валидаторы через
 *    `new Function` — это те самые `VM…` в стеках.
 *
 * `jitless: true` убирает оба: под ним проба пропускается (zod 4.4+), а схемы
 * интерпретируются вместо компиляции.
 *
 * ЦЕНА. Её нет — и это выяснилось замером, а не рассуждением. Здесь сначала
 * стояло «валидация без JIT медленнее, но у нас всего десятки объектов на
 * действие пользователя». Вторая половина верна, первая оказалась НЕВЕРНОЙ.
 *
 * Замер на реальных событиях хаба match-live (20 000 разборов каждой схемы,
 * Node 22, сделан сессией эпиков 996/987 при подключении zod к SignalR):
 *
 *   MatchScoreUpdated, 3 поля         JIT 3.7 мкс → jitless 2.1 мкс
 *   VetoStateUpdated, 9 полей + массив JIT 23.1 мкс → jitless 12.1 мкс
 *
 * То есть под `jitless` разбор ВДВОЕ БЫСТРЕЕ: на схемах такого размера
 * компиляция не окупается, интерпретация выигрывает. Порог, за которым это
 * могло бы стать проблемой, — тысячи сообщений в секунду; в match-live даже
 * в разгар турнира разбор стоит доли процента кадра.
 *
 * Оговорка о методе: это микробенчмарк в Node, он отвечает на вопрос «дорог ли
 * сам разбор» и не отвечает на «как это в браузере под нагрузкой». Разница в
 * масштабах такова, что второй вопрос можно не задавать.
 *
 * ПОЧЕМУ ОТДЕЛЬНЫЙ МОДУЛЬ И ГДЕ ОН ИМПОРТИРУЕТСЯ. `allowsEval` мемоизируется
 * при первом обращении: настройка, сделанная после первого `parse`, уже ни на
 * что не влияет — проба к тому моменту выполнена, нарушение записано.
 *
 * Поэтому импорт стоит в `instrumentation-client.ts`: Next выполняет его до
 * гидрации и до любых компонентов. Первая версия импортировала этот модуль из
 * `app/root-content.tsx`, и этого не хватило — на проде осталось ровно одно
 * нарушение из тринадцати: одна схема успевала разобраться раньше корневого
 * клиентского компонента. Нашлось `ReportingObserver`'ом с `buffered: true`,
 * который отдал отчёт с точной колонкой в чанке zod.
 *
 * Менять место импорта — только понимая это: «работает почти всегда» здесь
 * означает «нарушение осталось, просто его стало одно».
 */
config({ jitless: true });

/** Пустой экспорт: модуль нужен ради побочного эффекта, но `import "…"` без
 *  привязки бандлеры любят вытряхивать как «неиспользуемый». */
export const zodConfigured = true;
